import { Component } from '@angular/core';

@Component({
    selector: 'marketingapp',
    template: ` <router-outlet></router-outlet> `,
})
export class MarketingComponent {}
